// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import { store } from './store/store.js'
import { routes } from './routes.js'

Vue.config.productionTip = false

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history'
})

// let app

// Firebase.auth().onAuthStateChanged(function (user) {
//   if (!app) {
//     app = new Vue({
//       el: '#app',
//       router,
//       store,
//       components: { App },
//       template: '<App/>'
//     })
//   }
// })

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js